<div class="mobile-modal__body tui-space_all-8">
  <h3 class="tui-text_h3 tui-space_bottom-4">👋 {{ 'Hey' | translate }}!</h3>
  <p class="tui-space_bottom-4 ait-font-text-m">
    {{ 'Our platform is best used on a desktop' | translate }}.
  </p>
  <p class="tui-space_bottom-4 ait-font-text-m">
    {{ 'Watch the video how it works' | translate }}:
  </p>
  <app-youtube-embedded
    [youtubeTutorVideo]="youtubeTutorVideo"
    width="100%"
    height="auto"
  ></app-youtube-embedded>
  <button
    class="tui-space_top-4 ait-fullwidth"
    (click)="close()"
    tuiButton
    type="button"
    appearance="primary"
    size="m"
  >
    {{ 'Ok' | translate }}
  </button>
</div>
